'use client';
import { GridCollection } from '@zag-js/collection';

const createGridCollection = (options) => new GridCollection(options);

export { createGridCollection };
